module.exports = __webpack_public_path__ + "img/oee-4.fc8e5083.png";